import React from 'react';
import {
  FDBox, FDIcon, FDStack, FDTooltippedText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import Resource from 'facet-rest/src/domain/Resource';

const ServiceItem = ({ serviceItem }) => {
  return (
    <FDStack direction={'row'} justifyContent={'space-between'} spacing={2}>
      <FDTooltippedText label={serviceItem.attr('name')} description={serviceItem.attr('description')} />
      <FDBox paddingX={4}>
        {serviceItem.isTruthy('included') ? (
          <FDIcon icon={'checkCircleIcon'} color={'success'} size={'sm'} />
        ) : (
          <FDIcon icon={'closeOutline'} color={'textDisabled'} size={'sm'} />
        )}
      </FDBox>
    </FDStack>
  );
};

ServiceItem.defaultProps = {};

ServiceItem.propTypes = {
  serviceItem: PropTypes.instanceOf(Resource).isRequired,
};

export { ServiceItem };
